import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import CommsPanelsProvider from './contexts/CommsPanelProvider';
import { CookiesProvider } from 'react-cookie';
import Socket from './components/Socket';
import Header from './components/Header/Header';
import Body from './components/Body';
import store from './store';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';



// Necessary for all datagrids...
import { LicenseInfo } from '@mui/x-license-pro';
import EmailSmsPanels from './components/Panels';

const App = () => {
    LicenseInfo.setLicenseKey( 'dd74b380ee7166e981fcf535339d6a68Tz0xMTc5MzEsRT0xNzg3MjcwMzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=' );
    // 'fc010fb1403de51517dfa9fcc535d42bTz05NjM1MCxFPTE3NTU0NTc2NDAwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPWluaXRpYWwsS1Y9Mg==' );
    // '61a8aa637fe9ca53f3896e4cc5af74faTz03MjgyNyxFPTE3MjM4MDQyMjIwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=' );

    return (
        <Provider store={store}>
            <CookiesProvider>
                <Socket>
                    <CommsPanelsProvider>
                        <Router>
                            <Header />
                            <Body />
                        </Router>
                        <EmailSmsPanels />
                    </CommsPanelsProvider>
                </Socket>
            </CookiesProvider>
        </Provider>
    );
}

export default App;
